// custom-header.js
document.addEventListener('DOMContentLoaded', () => {
  // Setup Mega Menu Carousel arrows
  const megaMenus = document.querySelectorAll('.custom-mega-menu');
  
  megaMenus.forEach(menu => {
    const carousel = menu.querySelector('.mega-menu-carousel');
    const prevBtn = menu.querySelector('.mega-prev-btn');
    const nextBtn = menu.querySelector('.mega-next-btn');
    
    if (carousel && prevBtn && nextBtn) {
      // Calculate scroll amount based on item width
      const scrollAmount = () => {
        const item = carousel.querySelector('.mega-menu-product');
        if (item) {
          // scroll by 1 item + gap
          return item.offsetWidth + 20;
        }
        return 300;
      };

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        carousel.scrollBy({
          left: -scrollAmount(),
          behavior: 'smooth'
        });
      });

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        carousel.scrollBy({
          left: scrollAmount(),
          behavior: 'smooth'
        });
      });
    }
  });

  // Handle accessible click toggling for nav links
  const navLinks = document.querySelectorAll('.custom-nav-link');
  
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const parent = link.closest('.custom-nav-item');
      if (parent.classList.contains('has-mega-menu')) {
        // e.preventDefault(); /* Allow navigation to the link URL */
        
        const isExpanded = link.getAttribute('aria-expanded') === 'true';
        
        // Close all others
        navLinks.forEach(otherLink => {
          if (otherLink !== link) {
            otherLink.setAttribute('aria-expanded', 'false');
          }
        });
        
        // Toggle current
        link.setAttribute('aria-expanded', !isExpanded);
      }
    });
  });

  // Close mega menus on click outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.custom-header-nav')) {
      navLinks.forEach(link => {
        link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // Search Toggle
  const searchOverlay = document.getElementById('customSearchOverlay');
  const searchInput = document.getElementById('customSearchInput');
  const searchToggles = document.querySelectorAll('.search-toggle-btn');
  
  if (searchOverlay && searchToggles) {
    searchToggles.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        searchOverlay.classList.toggle('is-active');
        if (searchOverlay.classList.contains('is-active') && searchInput) {
          setTimeout(() => searchInput.focus(), 300);
        }
      });
    });

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
        searchOverlay.classList.remove('is-active');
      }
    });
  }

  // Mobile Menu Toggle
  const mobileDrawer = document.getElementById('customMobileDrawer');
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileClose = document.querySelector('.mobile-menu-close');

  if (mobileDrawer && mobileToggle && mobileClose) {
    mobileToggle.addEventListener('click', (e) => {
      e.preventDefault();
      mobileDrawer.classList.add('is-active');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    });

    mobileClose.addEventListener('click', (e) => {
      e.preventDefault();
      mobileDrawer.classList.remove('is-active');
      document.body.style.overflow = '';
    });

    // Close when clicking outside
    mobileDrawer.addEventListener('click', (e) => {
      if (e.target === mobileDrawer) {
        mobileDrawer.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }
});

// Scroll behavior for Sticky Header
(function initStickyHeader() {
  const headerWrapper = document.getElementById('customHeaderContainer');
  if (!headerWrapper) return;

  // Find the actual scroll container
  const pageWrapper = document.querySelector('.page-wrapper');
  const isDesktop = window.innerWidth >= 990;
  const scrollContainer = (isDesktop && pageWrapper) ? pageWrapper : window;
  
  let getScrollTop = () => {
    if (scrollContainer === window) {
      return window.pageYOffset || document.documentElement.scrollTop;
    }
    return scrollContainer.scrollTop;
  };

  let lastScrollTop = getScrollTop();
  let headerHeight = headerWrapper.offsetHeight;
  let isFixed = false;
  
  // Create a placeholder to prevent content jump when header becomes fixed
  const placeholder = document.createElement('div');
  placeholder.style.height = headerHeight + 'px';
  placeholder.style.display = 'none';
  headerWrapper.parentNode.insertBefore(placeholder, headerWrapper);
  
  scrollContainer.addEventListener('scroll', () => {
    let scrollTop = getScrollTop();
    
    // We want the header to become fixed once we've scrolled past the announcement bar
    // Let's use 60px as a safe threshold (approx height of announcement bar)
    if (scrollTop > 60) {
      if (!isFixed) {
        headerWrapper.classList.add('is-fixed');
        placeholder.style.display = 'block';
        isFixed = true;
      }
      
      // Hide on scroll down, show on scroll up
      // Add a small buffer so it doesn't trigger immediately
      if (scrollTop > lastScrollTop && scrollTop > 150) {
        if (window.innerWidth >= 990) {
          headerWrapper.classList.add('is-hidden');
        }
      } else if (scrollTop < lastScrollTop) {
        headerWrapper.classList.remove('is-hidden');
      }
    } else {
      // At the very top -> reset everything
      if (isFixed && scrollTop <= 10) {
        headerWrapper.classList.remove('is-fixed');
        headerWrapper.classList.remove('is-hidden');
        placeholder.style.display = 'none';
        isFixed = false;
      }
    }
    
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }, { passive: true });

  // Handle resize to update heights and scroll container
  window.addEventListener('resize', () => {
    headerHeight = headerWrapper.offsetHeight;
    if (isFixed) placeholder.style.height = headerHeight + 'px';
    
    const newIsDesktop = window.innerWidth >= 990;
    if (newIsDesktop !== (scrollContainer === pageWrapper)) {
      location.reload();
    }
  });

  // Predictive Search Logic
  const searchInput = document.getElementById('customSearchInput');
  const resultsContainer = document.getElementById('predictiveSearchResults');
  
  if (searchInput && resultsContainer) {
    let debounceTimer;
    
    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      const query = this.value.trim();
      
      if (query.length < 2) {
        resultsContainer.classList.remove('active');
        resultsContainer.innerHTML = '';
        return;
      }
      
      debounceTimer = setTimeout(() => {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4')
          .then(response => response.json())
          .then(data => {
            const products = data.resources.results.products;
            if (products && products.length > 0) {
              let html = '';
              products.forEach(product => {
                html += `
                  <a href="${product.url}" class="predictive-search-item">
                    <img src="${product.image || 'https://cdn.shopify.com/s/images/admin/no-image-large.gif'}" alt="${product.title}">
                    <div class="predictive-search-item-info">
                      <span class="predictive-search-item-title">${product.title}</span>
                      <span class="predictive-search-item-price">${product.price}</span>
                    </div>
                  </a>
                `;
              });
              html += `<a href="/search?q=${encodeURIComponent(query)}" class="predictive-search-view-all">View all results</a>`;
              
              resultsContainer.innerHTML = html;
              resultsContainer.classList.add('active');
            } else {
              resultsContainer.innerHTML = '<div style="padding: 15px; text-align: center; color: #666;">No results found for "' + query + '"</div>';
              resultsContainer.classList.add('active');
            }
          })
          .catch(error => {
            console.error('Error fetching search suggestions:', error);
          });
      }, 300);
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!searchInput.contains(e.target) && !resultsContainer.contains(e.target)) {
        resultsContainer.classList.remove('active');
      }
    });
  }

  // Force click-outside to close cart drawer
  document.addEventListener('click', function(e) {
    const cartDrawer = document.querySelector('theme-drawer[open]');
    if (cartDrawer) {
      const path = e.composedPath();
      const innerContent = cartDrawer.querySelector('.drawer__panel') || cartDrawer.querySelector('.cart-drawer__inner');
      
      // If the user clicked a remove button or quantity button, don't close the drawer!
      if (e.target.closest('cart-remove-button') || e.target.closest('a[href*="/cart/change"]') || e.target.closest('button') || e.target.closest('a')) {
        if (innerContent && path.includes(innerContent)) return;
      }
      
      let isInsideDrawer = false;
      let isToggle = false;
      
      for (let i = 0; i < path.length; i++) {
        const el = path[i];
        if (!el || !el.tagName) continue;
        if (innerContent && el === innerContent) isInsideDrawer = true;
        if (el.tagName === 'CART-REMOVE-BUTTON') isInsideDrawer = true;
        if (el.classList && el.classList.contains('header__icon')) isToggle = true;
        if (el.getAttribute && (el.getAttribute('aria-controls') === 'cart-drawer' || el.getAttribute('on:click') === '#cart-drawer/toggle')) isToggle = true;
      }

      if (!isInsideDrawer && !isToggle) {
        if (typeof cartDrawer.close === 'function') {
          cartDrawer.close();
        } else {
          const closeBtn = cartDrawer.querySelector('.theme-drawer__close-button') || cartDrawer.querySelector('[on\\:click="#cart-drawer/close"]');
          if (closeBtn) closeBtn.click();
        }
      }
    }
  });
})();
